<template>
  <div
    v-loading.fullscreen.lock="fullScreenLoading"
    element-loading-text="loading..."
    element-loading-spinner="el-icon-loading"
    element-loading-background="rgba(0, 0, 0, 0.8)"
  >
    <div class="d-flex">
      <div class="item-title">订单类型：</div>
      <div class="item-text">
        <span>{{ formData.orderTypeName }}</span>
      </div>
      <div class="item-title">业务类型：</div>
      <div class="item-text">
        <span>{{ formData.bizTypeName }}</span>
      </div>
      <div class="item-title">运输模式：</div>
      <div class="item-text">
        <span>{{ formData.transportModeName }}</span>
      </div>
      <div class="item-title">车型需求：</div>
      <div class="item-text">
        <span>{{
          formData.vehicleModelName ? formData.vehicleModelName : '不限'
        }}</span>
      </div>
      <div class="item-title">车长需求：</div>
      <div class="item-text">
        <span>{{
          formData.vehicleLengthName ? formData.vehicleLengthName : '不限'
        }}</span>
      </div>
      <div class="item-title">是否返程：</div>
      <div class="item-text">
        <span>{{ formData.isBack ? '是' : '否' }}</span>
      </div>
    </div>
    <div class="d-flex">
      <div class="item-title">载重需求：</div>
      <div class="item-text">
        <span>{{ formData.vehicleLoad ? formData.vehicleLoad : '不限' }}</span>
      </div>
      <div class="item-title">载方需求：</div>
      <div class="item-text">
        <span>{{
          formData.vehicleVolume ? formData.vehicleVolume : '不限'
        }}</span>
      </div>
      <div class="item-title">总件数：</div>
      <div class="item-text">
        <span>{{ formData.totQty }} 件</span>
      </div>
      <div class="item-title">总重量：</div>
      <div class="item-text">
        <span>{{ formData.totInWeight }} kg</span>
      </div>
      <div class="item-title">总体积：</div>
      <div class="item-text">
        <span>{{ formData.totInVolume }} m³</span>
      </div>
      <div class="item-title">总货值：</div>
      <div class="item-text">
        <span>{{ formData.totValue }}</span>
      </div>
    </div>

    <div class="side-frame">
      <div>
        <span class="item-title" style="font-size:15px;">
          发货城市：
        </span>
        <span class="item-text" style="font-size:15px;">
          {{ formData.origin }}
        </span>
        <el-divider direction="vertical"></el-divider>
        <span class="item-title" style="font-size:15px;">
          地址：
        </span>
        <span class="item-text" style="font-size:15px;">
          {{ formData.pickupAddress }}
        </span>
      </div>
      <div>
        <span class="item-title" style="font-size:15px;">
          提货时间：
        </span>
        <span class="item-text" style="font-size:15px; color:#409EFF;">
          {{ formData.pickDatetimeBegin ? formData.pickDatetimeBegin : '--' }}
          至
          {{ formData.pickDatetimeEnd ? formData.pickDatetimeEnd : '--' }}
        </span>
      </div>
    </div>
    <transfer-table
      :dispatchOrderCode="formData.dispatchOrderCode"
      ref="table"
    />

    <div class="side-frame-success">
      <div>
        <span class="item-title" style="font-size:15px;">
          收货城市：
        </span>
        <span class="item-text" style="font-size:15px;">
          {{ formData.dest }}
        </span>
        <el-divider direction="vertical"></el-divider>
        <span class="item-title" style="font-size:15px;">
          地址：
        </span>
        <span class="item-text" style="font-size:15px;">
          {{ formData.receiveAddress }}
        </span>
      </div>
      <div>
        <span class="item-title" style="font-size:15px;">
          送达时间：
        </span>
        <span class="item-text" style="font-size:15px; color:#67C23A;">
          {{
            formData.receiveDatetimeBegin ? formData.receiveDatetimeBegin : '--'
          }}
          至
          {{ formData.receiveDatetimeEnd ? formData.receiveDatetimeEnd : '--' }}
        </span>
      </div>
    </div>

    <div class="dialog-footer mt-3 d-flex justify-content-end">
      <el-button @click="close()" size="small">
        取消
      </el-button>
      <el-button type="primary" @click="save()" size="small"
        >确认提交中转</el-button
      >
    </div>
  </div>
</template>
<script>
import TransferTable from './transfer-table'
export default {
  props: {
    formData: {
      type: Object,
      default: () => {}
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  components: { TransferTable },
  data() {
    return {
      fullScreenLoading: false
    }
  },
  watch: {
    formData: {
      handler(formData) {
        if (formData) {
          this.load()
        }
      },
      immediate: true
    }
  },
  methods: {
    load() {},
    async save() {
      const tableData = await this.$refs.table.getInsertRecords()
      if (tableData.length < 1) {
        this.$alert('请添加中转信息', '提示信息', {})
        return
      }

      let rowNo = 1
      let errMessage = ''
      tableData.forEach((item) => {
        if (!item.transferStationCode) {
          let msg = '第【' + rowNo + '】行，未设置中转站！'
          if (errMessage === '') {
            errMessage = msg
          } else {
            errMessage = errMessage + '<br/>' + msg
          }
        }
        if (!item.transportMode) {
          let msg = '第【' + rowNo + '】行，未设置运输模式！'
          if (errMessage === '') {
            errMessage = msg
          } else {
            errMessage = errMessage + '<br/>' + msg
          }
        }
        // if (!item.bizType) {
        //   let msg = '第【' + rowNo + '】行，未设置业务类型！'
        //   if (errMessage === '') {
        //     errMessage = msg
        //   } else {
        //     errMessage = errMessage + '<br/>' + msg
        //   }
        // }
        rowNo++
      })
      if (errMessage !== '') {
        this.$alert(errMessage, '提示信息', {
          dangerouslyUseHTMLString: true
        })
        return
      }

      let params = {
        dispatchOrderCode: this.formData.dispatchOrderCode,
        listStation: tableData
      }
      this.$api
        .bizDispatchPoolTransferSubmitApi(params)
        .then(() => {
          this.fullScreenLoading = false
          this.saveOk()
        })
        .catch(() => {
          this.fullScreenLoading = false
        })
    },
    close() {
      this.$emit('close')
    },
    saveOk() {
      this.$emit('saveOk')
    }
  }
}
</script>
<style lang="scss" scoped>
.line {
  text-align: center;
}
.item-title {
  width: 70px;
  font-size: 14px;
  color: #999999;
}
.item-text {
  width: 80px;
  font-size: 14px;
  color: #333333;
}
</style>
